export function match(param: string): boolean {
  return ['top', 'new'].includes(param);
}
